"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthorizeService_1 = require("./AuthorizeService");
/**
 * Hook to return the authentication service.
 */
function useAuthorizeService() {
    return AuthorizeService_1.default;
}
exports.useAuthorizeService = useAuthorizeService;
//# sourceMappingURL=useAuthorizeService.js.map